import { ResourceConfig } from '@eastcoal/router/types/resource'

export const menuTreeEqualityFn = (
  source: ResourceConfig,
  target: ResourceConfig
) => source.key === target.key
